module.exports = __webpack_public_path__ + "img/three_one.c896c4c9.png";